export const gtmId = {
  gtmId: process.env.GTM || 'GTM-PG8JLHP',
  auth: process.env.Auth || '6sBOnZx1hqPcO01xPOytLK',
  preview: process.env.preview || 'env-2',
};
